import Loadable from 'react-loadable';
import NextGlobalLoader from '../../components/next/NextGlobalLoader';
import NextPublicGlobalLoader from '../../components/next/NextPublicGlobalLoader';

// Exceptions pages
export const NotFoundPage = Loadable({
  loader: () => import('./Exceptions/NotFoundPage'),
  loading: NextGlobalLoader,
});

// Security Pages
export const LoginPage = Loadable({
  loader: () => import('./Security/Login'),
  loading: NextPublicGlobalLoader,
});

export const SignUpPage = Loadable({
  loader: () => import('./Security/SignUp'),
  loading: NextPublicGlobalLoader,
});

export const ManageUserPage = Loadable({
  loader: () => import('./Security/ManageUser'),
  loading: NextPublicGlobalLoader,
});

export const RecordScheduledVisit = Loadable({
  loader: () => import('./ScheduledVisits/RecordScheduledVisit'),
  loading: NextGlobalLoader,
});

export const ScheduledVisitsPage = Loadable({
  loader: () => import('./ScheduledVisits'),
  loading: NextGlobalLoader,
});

// Dashboard Pages
export const HomePage = Loadable({
  loader: () => import('./Home'),
  loading: NextGlobalLoader,
});

// Help Desk Pages
export const ApproveTicketPage = Loadable({
  loader: () => import('./HelpDesk/ApproveTickets'),
  loading: NextGlobalLoader,
});

export const AttendTicketPage = Loadable({
  loader: () => import('./HelpDesk/AttendTickets'),
  loading: NextGlobalLoader,
});

export const CheckTicketsPage = Loadable({
  loader: () => import('./HelpDesk/CheckTickets'),
  loading: NextGlobalLoader,
});

export const ContactsPage = Loadable({
  loader: () => import('./HelpDesk/Contacts'),
  loading: NextGlobalLoader,
});

export const CreateTicketPage = Loadable({
  loader: () => import('./HelpDesk/CreateTicket'),
  loading: NextGlobalLoader,
});

export const MyTicketsPage = Loadable({
  loader: () => import('./HelpDesk/MyTickets'),
  loading: NextGlobalLoader,
});

// Manufacturing Routes
export const RequestsPage = Loadable({
  loader: () => import('./ManufacturingRoutes/Requests'),
  loading: NextGlobalLoader,
});
export const RequestsSumaryPage = Loadable({
  loader: () => import('./ManufacturingRoutes/Requests'),
  loading: NextGlobalLoader,
});
export const NewRequestPage = Loadable({
  loader: () => import('./ManufacturingRoutes/NewRequest'),
  loading: NextGlobalLoader,
});
export const CreationRoutePage = Loadable({
  loader: () => import('./ManufacturingRoutes/Route'),
  loading: NextGlobalLoader,
});
export const ConsolidatedMaterialsPage = Loadable({
  loader: () => import('./ManufacturingRoutes/Route/Report'),
  loading: NextGlobalLoader,
});
export const ConsolidatedRecipePage = Loadable({
  loader: () => import('./ManufacturingRoutes/Route/Report'),
  loading: NextGlobalLoader,
});
export const ConsolidatedVersionPage = Loadable({
  loader: () => import('./ManufacturingRoutes/Route/Report'),
  loading: NextGlobalLoader,
});
export const TypeMaterialPage = Loadable({
  loader: () => import('./ManufacturingRoutes/Configuration/TypeMaterial'),
  loading: NextGlobalLoader,
});
export const LoadMaterialPage = Loadable({
  loader: () => import('./ManufacturingRoutes/Route/LoadMaterial'),
  loading: NextGlobalLoader,
});
export const ResourcesPage = Loadable({
  loader: () => import('./ManufacturingRoutes/Configuration/Resources'),
  loading: NextGlobalLoader,
});
export const SpeedTrefiladoPage = Loadable({
  loader: () => import('./ManufacturingRoutes/Configuration/SpeedTrefilado'),
  loading: NextGlobalLoader,
});
export const SpeedVarillaPage = Loadable({
  loader: () => import('./ManufacturingRoutes/Configuration/SpeedVarilla'),
  loading: NextGlobalLoader,
});
export const SpeedPlastificadoPage = Loadable({
  loader: () => import('./ManufacturingRoutes/Configuration/SpeedPlastificado'),
  loading: NextGlobalLoader,
});
export const SpeedAlambreGalvanizadoPage = Loadable({
  loader: () =>
    import('./ManufacturingRoutes/Configuration/SpeedAlambreGalvanizado'),
  loading: NextGlobalLoader,
});
export const SkuSheetOlimpicaPage = Loadable({
  loader: () => import('./ManufacturingRoutes/SkuSheet/MallaOlimpica'),
  loading: NextGlobalLoader,
});
export const SkuSheetOlimpicaPlastificadaPage = Loadable({
  loader: () =>
    import('./ManufacturingRoutes/SkuSheet/MallaOlimpicaPlastificada'),
  loading: NextGlobalLoader,
});
export const IndicatorsPage = Loadable({
  loader: () => import('./ManufacturingRoutes/Indicators'),
  loading: NextGlobalLoader,
});
